<app-secondary-header
  class="desktop-toggle"
  [headerTitle]="'Select Date & Time'"
  (changeView)="handleChangeAction($event)"
>
</app-secondary-header>
<ion-content>
  <div class="secondary-header">
    <app-secondary-header
      [headerTitle]="'Select Date & Time'"
      [centerTitle]="true"
      (changeView)="handleChangeAction($event)"
    >
    </app-secondary-header>
  </div>
  <div class="calendar-container" *ngIf="!!currentOffice">
    <app-calendar
      [officeSelected]="currentOffice"
      (nextView)="goToFinalizeView($event)"
    ></app-calendar>
  </div>
</ion-content>
